import { useMount, useRequest } from "ahooks";
import Cookies from "js-cookie";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";

import { TOKEN_IN_COOKIE } from "@/libs/constants";
import { getStructuresData } from "@/libs/structures";
import { staffState, userPermissionsState } from "@/models";
import { getAuthInfoReq, getPermissionReq } from "@/services/api";
import { showIndexHeader } from "@/utils/route";

import styles from "./index.module.less";
import { useStore } from "./use-store";

export const IndexPage = () => {
  // eslint-disable-next-line no-empty-pattern
  const {} = useStore();

  const { pathname } = useLocation();

  const location = useLocation();

  const navigate = useNavigate();

  const [permission, setPermission] = useRecoilState(userPermissionsState);

  const [staff, setStaff] = useRecoilState(staffState);

  const getPermissionRequest = useRequest(getPermissionReq, {
    manual: true,
    onSuccess: (result) => {
      const { data } = result;

      setPermission(data);
    },
  });

  const getAuthInfoRequest = useRequest(getAuthInfoReq, {
    manual: true,
    onSuccess: (result) => {
      setStaff(result.data.staff);
    },
  });

  useMount(() => {
    const token = Cookies.get(TOKEN_IN_COOKIE);

    if (token && !staff) {
      getAuthInfoRequest.run();
    }
  });

  useEffect(() => {
    if (pathname === "/") {
      navigate("/index-page");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
  const minHeight = window.innerHeight - 80; // 80:头部高度

  useEffect(() => {
    getStructuresData();
    getPermissionRequest.run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="body"
      style={{
        height: minHeight,
        marginTop: showIndexHeader(pathname) ? "" : 0,
      }}
    >
      <Outlet />
    </div>
  );
};
export default IndexPage;
